import React from "react";

import PropTypes from "prop-types";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { H1, Paragraph, Ingress } from "BaseComponents/Text";
import { ColoredButton, ButtonText } from "BaseComponents/Button";
import { Arrow } from "BaseComponents/Icons/Svg";
import { Cog } from "../../BaseComponents/Icons/Svg";
import { useGlobal } from "reactn";

export const ErrorPageWrapper = styled.div`
	width: 100%;
	padding: 5rem 1rem;

	${media.greaterThan(breakpoints.ipad)`
     min-height: 800px;
     `}
`;
export const ErrorPageContentWrapper = styled.div`
	flex-direction: column;
	display: flex;
	max-width: 800px;
	margin: 0 auto;
`;
export const HeaderWrapper = styled.div`
	display: flex;
	margin: 1rem 0;
	justify-content: space-between;
	align-items: center;
`;
export const ErrorHeader = styled.h1`
	color: ${({ theme }) => theme.colors.primary};
	font-size: 120px;
	margin: 2rem 0rem;
`;

export const Underline = styled.div`
	border-bottom: 3px solid ${({ theme }) => theme.colors.grey};
	height: 10px;
`;

export const ErrorIngress = styled.p`
	font-size: 16px;
	line-height: 22px;
	display: inline-block;
	font-weight: bold;
	font-size: 24px;
	line-height: 1.38;
	margin: 1rem 0 1rem 0;
`;
export const ErrorButton = styled(ColoredButton)`
	svg {
		stroke: ${({ theme }) => theme.colors.black};
	}
	&:hover {
		svg {
			stroke: white;
		}
	}
`;

const ErrorPage = ({ Heading, ErrorText, CurrentStartPage, ErrorCode }) => {
	const [theme] = useGlobal("theme");
	return (
		<ErrorPageWrapper>
			<ErrorPageContentWrapper>
				<HeaderWrapper>
					<ErrorHeader size="120px">{ErrorCode}</ErrorHeader>
					<Cog color={theme.colors.secondary} width="74px" height="60px" />
				</HeaderWrapper>
				<Ingress>{ErrorText}</Ingress>
				<Underline />
				<ErrorIngress bold fontSize="24px">
					{Heading}
				</ErrorIngress>
				<ErrorButton
					widthsmall="180px"
					borderradius="500px"
					height="50px"
					bgColor={theme.colors.darkgrey}
					href={CurrentStartPage}
				>
					<ButtonText>Startsida</ButtonText>
					<Arrow></Arrow>
				</ErrorButton>
			</ErrorPageContentWrapper>
		</ErrorPageWrapper>
	);
};

export default ErrorPage;
